<!-- 翻车机作业记录 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
    <SelectWagonOperationPlanList ref="selectWagonOperationPlan" @replace="replace"></SelectWagonOperationPlanList>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";
import SelectWagonOperationPlanList from "./components/select-operation-plan-list.vue"

export default {
  components: {SelectWagonOperationPlanList},
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '作业编号',
            prop: 'operationNo',
            search: true, // 查询是否显示
            minWidth: 180,
            rules: [
              {required: true, message: '请录入作业编号', trigger: 'blur'}
            ],
          },
          {
            label: '设备编码',
            prop: 'deviceCode',
          },
          {
            label: '作业日期',
            prop: 'operationDate',
            type: 'date',
            search: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            minWidth: 120,
            remote: true,
            readonly: true,
            rules: [
              {required: true, message: '请选择作业日期', trigger: 'blur'}
            ],
            // 可以设置默认值为今天
            // value: this.getTodayDate(),
            click: () => {
              this.$refs.selectWagonOperationPlan.open()
            },
          },
          {
            label: '开始时间',
            prop: 'startTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            change: this.calculateTotalSeconds // 添加change事件
          },
          {
            label: '结束时间',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            change: this.calculateTotalSeconds // 添加change事件
          },
          {
            label: '总耗时(秒)',
            prop: 'totalSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            disabled: true, // 设置为只读
            value: 0 // 默认值0
          },
          {
            label: "作业状态",
            prop: "operationStatus",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=operation_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择作业状态', trigger: 'change'}
            ],
          },
          {
            label: '翻卸车数',
            prop: 'vehicleCount',
            type: 'number',
            search: false,
            readonly: true,
            rules: [
              {required: true, message: '请输入翻卸车数', trigger: 'blur'},
            ],
            precision: 0, // 整数
            step: 1, // 步长为1
          },
          {
            label: '数据来源协议',
            prop: 'dataSource',
            hide: true,//在表格中隐藏
          },
          {
            label: '物料类型',
            prop: 'materialType',
          },
          {
            label: '计划ID',
            prop: 'planId',
            type: 'number',
            hide: true,//在表格中隐藏
          },
          {
            label: '摘勾至翻车耗时(秒)',
            prop: 'hookToUnloadSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0 // 默认值0
          },
          {
            label: '翻车至清扫耗时(秒)',
            prop: 'unloadToCleanSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0 // 默认值0
          },
          {
            label: '环节耗时占比JSON',
            prop: 'phaseDurationRatio',
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            label: '效率(车厢/小时)',
            prop: 'efficiencyRate',
            type: 'number',
            precision: 2,
            value: 0,
            hide: true,//在表格中隐藏
          },
          {
            label: "是否超时",
            prop: "is_overtime",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_overtime",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择是否超时', trigger: 'change'}
            ],
            value: 0
          },
          {
            label: '超时秒数(秒)',
            prop: 'overtimeSeconds',
            type: 'number',
            precision: 0, // 整数
            step: 1, // 步长为1
            value: 0 // 默认值0
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '备注',
            prop: 'remark',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 50, message: '备注不能超过50个字符', trigger: 'blur'}
            ]
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false // 时间范围查询
          },
        ]
      },
    }
  },
  methods: {
    /**
     * 获取今天日期的字符串（yyyy-MM-dd格式）
     */
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /**
     * 计算总耗时（秒）
     * 总耗时 = 结束时间 - 开始时间（单位：秒）
     */
    calculateTotalSeconds() {
      // 确保两个时间字段都有值
      if (this.form.startTime && this.form.endTime) {
        try {
          const start = new Date(this.form.startTime);
          const end = new Date(this.form.endTime);
          // 验证时间有效性
          if (isNaN(start.getTime()) || isNaN(end.getTime())) {
            this.form.totalSeconds = 0;
            return;
          }
          // 计算时间差（毫秒）并转换为秒
          const diffMs = end.getTime() - start.getTime();
          // 确保结束时间不早于开始时间
          if (diffMs < 0) {
            this.form.totalSeconds = 0;
            // 可以添加错误提示
            this.$message.warning('结束时间不能早于开始时间');
            return;
          }
          // 转换为秒并取整
          this.form.totalSeconds = Math.round(diffMs / 1000);
        } catch (error) {
          console.error('计算总耗时失败:', error);
          this.form.totalSeconds = 0;
        }
      } else {
        // 如果任一时间为空，设置总耗时为0
        this.form.totalSeconds = 0;
      }
    },

    /**
     * 在打开对话框前设置默认值
     */
    beforeOpen(done, type) {
      if (type === 'add') {
        // 新增时设置默认值
        this.$nextTick(() => {
          this.form.operationDate = this.getTodayDate();
          this.form.status = 1;
          this.form.totalSeconds = 0; // 设置总耗时默认值
        });
      }
      done();
    },

    /**
     * 从选择组件接收数据并赋值给表单
     * 处理字段映射：选择组件的字段名与当前表单字段名不一致的情况
     * @param {Object} row - 选择的行数据
     */
    replace(row) {
      // 定义字段映射关系
      // key: 当前表单字段名
      // value: 选择组件返回的对应字段名
      const fieldMapping = {
        'operationDate': 'planDate',        // 作业日期-计划日期映射
        'vehicleCount': 'actualVehicles',          // 翻卸车数-实际卸载车数映射
        'planId': 'id', //计划ID-计划主键ID
      };
      // 遍历映射关系并设置值
      Object.keys(fieldMapping).forEach(currentField => {
        const sourceField = fieldMapping[currentField];
        if (row[sourceField] !== undefined && row[sourceField] !== null) {
          this.$set(this.form, currentField, row[sourceField]);
        }
      });
      // console.log('从选择组件接收的数据:', row);
      // console.log('映射后的表单数据:', this.form);
    },

  },
  watch: {
    // 监听开始时间和结束时间的变化，确保实时计算
    'form.startTime': {
      handler() {
        this.calculateTotalSeconds();
      }
    },
    'form.endTime': {
      handler() {
        this.calculateTotalSeconds();
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
